import { apiClient } from '../client'
import type { ApiPaginatedResponse, ApiSuccessResponse } from '../../types/api'
import type {
  AssistantCreatePayload,
  AssistantDoctorLink,
  AssistantListParams,
  AssistantUpdatePayload,
} from '../../types/assistant'

export const assistantService = {
  async list(params?: AssistantListParams) {
    const { data } = await apiClient.get<
      ApiPaginatedResponse<AssistantDoctorLink> | ApiSuccessResponse<AssistantDoctorLink[]>
    >('/doctor/assistants', { params })
    return data
  },

  async show(id: string) {
    const { data } = await apiClient.get<ApiSuccessResponse<AssistantDoctorLink>>(
      `/doctor/assistants/${id}`,
    )
    return data
  },

  async create(payload: AssistantCreatePayload) {
    const { data } = await apiClient.post<ApiSuccessResponse<AssistantDoctorLink>>(
      '/doctor/assistants',
      payload,
    )
    return data
  },

  async update(id: string, payload: AssistantUpdatePayload) {
    const { data } = await apiClient.put<ApiSuccessResponse<AssistantDoctorLink>>(
      `/doctor/assistants/${id}`,
      payload,
    )
    return data
  },

  async remove(id: string, options?: { doctorId?: string; skipErrorToast?: boolean }) {
    const { data } = await apiClient.delete<ApiSuccessResponse<null>>(
      `/doctor/assistants/${id}`,
      {
        params: options?.doctorId ? { doctor_id: options.doctorId } : undefined,
        skipErrorToast: options?.skipErrorToast,
      },
    )
    return data
  },

  async restore(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<AssistantDoctorLink>>(
      `/doctor/assistants/${id}/restore`,
    )
    return data
  },

  async disable(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<AssistantDoctorLink>>(
      `/doctor/assistants/${id}/disable`,
    )
    return data
  },

  async enable(id: string) {
    const { data } = await apiClient.post<ApiSuccessResponse<AssistantDoctorLink>>(
      `/doctor/assistants/${id}/enable`,
    )
    return data
  },

  async doctorPicker() {
    const { data } = await apiClient.get<ApiSuccessResponse<AssistantDoctorLink[]>>(
      '/assistants/doctor-picker',
    )
    return data
  },

  async linkedDoctors() {
    const { data } = await apiClient.get<ApiSuccessResponse<AssistantDoctorLink[]>>(
      '/assistants/linked-doctors',
    )
    return data
  },
}
